/**
 * Excerpt from `recompose`
 */
import React from 'react';
import { identity } from 'ramda';

export const wrapDisplayName = (BaseComponent, hocName) => `${hocName}(${getDisplayName(BaseComponent)})`;

export const getDisplayName = (Component$$1) => {
    if (typeof Component$$1 === 'string') {
        return Component$$1;
    }

    if (!Component$$1) {
        return undefined;
    }

    return Component$$1.displayName || Component$$1.name || 'Component';
};

export const setDisplayName = displayName => setStatic('displayName', displayName);

export const setStatic = (key, value) =>
    (BaseComponent) => {
        BaseComponent[key] = value;

        return BaseComponent;
    };

export const branch = (test, left, right = identity) =>
    (BaseComponent) => {
        let LeftComponent;
        let RightComponent;

        const Branch = (props) => {
            if (test(props)) {
                LeftComponent = LeftComponent || left(BaseComponent);
                return <LeftComponent {...props} />;
            }

            RightComponent = RightComponent || right(BaseComponent);
            return <RightComponent {...props} />;
        };

        if (process.env.NODE_ENV !== 'production') {
            return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
        }

        return Branch;
    };
